const { VITE_USER_POOL_ID, VITE_USER_POOL_WEB_CLIENT_ID } = import.meta.env;

const config = {
  Auth: {
    Cognito: {
      userPoolId: VITE_USER_POOL_ID,
      userPoolClientId: VITE_USER_POOL_WEB_CLIENT_ID,
    },
  },
};

export default config;
